module.exports = __webpack_public_path__ + "media/images/favicon/google-play-store-ab40379c1f3e920ef29d695d04aeeeaf.png";